/**
 * @name: Similar Products
 * @author: Cursor (Agent)
 * @date: 2026-09-25
 * @description: Initializes the same-vendor recommendations slider
 * @strict-mode: true
 */

window._theme = window._theme || {};

/**
 * Keep recommendation carousels left-aligned when there are fewer
 * products than slidesToShow (Slick otherwise centers the track).
 * @param {object} slick
 * @returns {void}
 */
window._theme.alignRecommendationSlider = (slick) => {
  if (!slick?.$slideTrack?.length) return;

  const slidesToShow = Number(slick.options.slidesToShow) || 1;

  if (slick.slideCount > Math.ceil(slidesToShow)) return;

  slick.$slideTrack.css({
    transform: 'translate3d(0px, 0px, 0px)',
    marginLeft: 0,
  });
};

/**
 * @extends {HTMLElement}
 */
class SimilarProducts extends HTMLElement {
  connectedCallback() {
    this.style.display = 'block';

    if (this.dataset.layout !== 'slider') return;

    this.#initSlider();
  }

  disconnectedCallback() {
    const slider = this.querySelector('[data-similar-products-list]');

    if (!slider || !window.jQuery) return;

    const $slider = window.jQuery(slider);

    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
  }

  #initSlider() {
    const slider = this.querySelector('[data-similar-products-list]');

    if (!slider) return;

    const columns = Number(this.dataset.columns) || 5;
    const prevLabel = this.dataset.prevLabel || 'Previous';
    const nextLabel = this.dataset.nextLabel || 'Next';

    const init = () => {
      if (!window._theme || typeof window._theme.initSlickSlider !== 'function') {
        setTimeout(init, 50);
        return;
      }

      if (!window.jQuery) {
        setTimeout(init, 50);
        return;
      }

      const $slider = window.jQuery(slider);

      if ($slider.hasClass('slick-initialized')) return;

      window._theme.initSlickSlider(
        $slider,
        {
          rows: 0,
          dots: false,
          arrows: true,
          accessibility: true,
          infinite: false,
          mobileFirst: true,
          speed: 400,
          slidesToShow: 1.5,
          slidesToScroll: 1,
          prevArrow: `<button class="slick-prev slick-arrow" aria-label="${prevLabel}" type="button"><i class="arrow1 left1"></i><span class="sr-only">${prevLabel}</span></button>`,
          nextArrow: `<button class="slick-next slick-arrow" aria-label="${nextLabel}" type="button"><i class="arrow1 right1"></i><span class="sr-only">${nextLabel}</span></button>`,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              },
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: columns,
                slidesToScroll: columns,
              },
            },
          ],
        },
        (slick) => {
          if (!slick || !slick.$slider) return;

          slick.$slider[0].querySelectorAll('.slick-slide').forEach((slide) => {
            slide.removeAttribute('tabindex');
          });

          window._theme.alignRecommendationSlider(slick);
          slick.$slider
            .off('setPosition.alignLeft')
            .on('setPosition.alignLeft', () => window._theme.alignRecommendationSlider(slick));
        }
      );
    };

    init();
  }
}

if (!customElements.get('similar-products')) {
  customElements.define('similar-products', SimilarProducts);
}
